import React from 'react';

import {
  Tab,
  TabsList,
  Container,
  TabButton,
  BorderLine,
  MainContainer,
} from './styles';

interface Props {
  tabs: string[];
  selected: number;
  onSelect: (index: number) => void;
}

const TabBar = ({
  tabs,
  selected,
  onSelect,
  children,
}: React.PropsWithChildren<Props>) => {
  const activeRef = React.useRef<HTMLButtonElement | null>(null);

  const [left, setLeft] = React.useState(0);
  const [width, setWidth] = React.useState(0);

  React.useEffect(() => {
    if (activeRef.current) {
      setWidth(activeRef.current.offsetWidth);
      setLeft(activeRef.current.offsetLeft);
    }
  }, [selected]);

  return (
    <MainContainer>
      <Container>
        <TabsList>
          {tabs.map((tab, index) => {
            return (
              <TabButton
                key={tab}
                onClick={() => onSelect(index)}
                ref={index === selected ? activeRef : null}
              >
                {tab}
              </TabButton>
            );
          })}
        </TabsList>
        <BorderLine style={{ width, left }} />
      </Container>

      {Array.isArray(children) && children[selected]}
    </MainContainer>
  );
};

export { Tab };
export { TabBar };
